<div
  class="products-shop-main"
  [ngClass]="{
    'products-shop-main-on-offer': productsOnOffer || productsQuerySearch
  }"
>
  <div class="container">
    <div
      class="products-shop-filter"
      [@enterAnimation]
      *ngIf="!isMobile || (isMobile && showFilterMobile)"
    >
      <div class="products-shop-filter-header mobile-visible">
        <p><i class="pi pi-filter"></i>Filtros</p>
        <i
          class="pi pi-times"
          (click)="
            showFilterMobile = !showFilterMobile;
            addOverflowHiddenToBody(showFilterMobile)
          "
        ></i>
      </div>
      <div class="products-shop-filter-content" *ngIf="!productsOnOffer">
        <div class="products-shop-filter-item">
          <div class="products-shop-filter-item-content">
            <p>SUBCATEGORIAS</p>
            <div
              *ngFor="let sub of categorySelected?.subCategories"
              class="field-checkbox"
            >
              <p-radioButton
                [inputId]="sub.id + '-input'"
                [(ngModel)]="subCategorySelected"
                name="category"
                [value]="sub"
                (onClick)="onClickSubCategory(); addOverflowHiddenToBody(false)"
              ></p-radioButton>
              <label [for]="sub.id + '-input'">{{ sub.description }}</label>
            </div>
          </div>
        </div>

        <div
          class="products-shop-filter-item"
          *ngFor="let filter of filterProductsShop; let i = index"
        >
          <p *ngIf="filter.visible">{{ filter?.title }}</p>
          <div *ngIf="filter.visible" class="products-shop-filter-item-content">
            <div
              class="field-checkbox"
              *ngFor="let value of filter.values; let subIndex = index"
            >
              <p-radioButton
                [inputId]="value.id + '-' + i + '-' + subIndex"
                [(ngModel)]="filter.filterSelected"
                name="{{ filter.name }}"
                [value]="value"
                (onClick)="
                  onClickFilter(filter); addOverflowHiddenToBody(false)
                "
              ></p-radioButton>
              <label [for]="value?.id + '-' + i + '-' + subIndex">{{
                value?.description
              }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="products-shop-content">
      <h2>{{ subCategorySelected?.description }}</h2>
      <div class="products-shop-content-header" *ngIf="hasProducts()">
        <p>{{ pageResponse ? pageResponse.totalElements : 0 }} PRODUTO(S)</p>

        <app-products-shop-order
          (changed)="changedOrderProducts($event)"
        ></app-products-shop-order>

        <button
          *ngIf="!productsOnOffer"
          class="button-rm mobile-visible"
          aria-label="Abrir tela de filtros"
          type="submit"
          (click)="
            showFilterMobile = !showFilterMobile;
            addOverflowHiddenToBody(showFilterMobile)
          "
        >
          FILTROS
        </button>
      </div>
      <div class="products-shop-content-products">
        <ng-container *ngFor="let product of products">
          <div class="products-shop-item">
            <a routerLink="{{ '/' + product.url }}">
              <img
                src="{{ product.mainPhotoS3Url }}"
                [alt]="'Foto: ' + product.name"
                width="251"
                height="251"
              />
              <div
                *ngIf="product?.featuredBanner || (product?.discount || 0) > 0"
                class="products-shop-item-featured"
              >
                {{
                  product.featuredBanner || product?.discount + "% DE DESCONTO"
                }}
              </div>
              <p class="products-shop-content-name">
                {{ product.name }}
              </p>

              <div class="products-shop-content-value">
                <p *ngIf="(product?.discount || 0) > 0" class="discount">
                  de
                  <span>{{ product.value | customCurrencyLight }}</span> por
                </p>
                <p class="total">
                  {{ product.valueWithDiscount | customCurrencyLight }}
                  {{ product.productPerSquareMeter ? " m²" : "" }}
                  <span>{{ product.valueInterestFree }}</span>
                </p>
              </div>
              <div class="add-to-cart" title="Adicionar ao Carrinho">
                <button
                  type="button"
                  pButton
                  pRipple
                  class="button-rm button-rm-green"
                  aria-label="Acessar seu carrinho para finalizar sua compra"
                  label="COMPRA RÁPIDA"
                  (click)="
                    onClickAddToCart(product, true);
                    $event.stopPropagation();
                    $event.preventDefault()
                  "
                ></button>
                <i
                  *ngIf="!product?.productPerSquareMeter"
                  class="pi pi-shopping-cart"
                  (click)="
                    onClickAddToCart(product, false);
                    $event.stopPropagation();
                    $event.preventDefault()
                  "
                ></i>
              </div>
            </a>
          </div>
        </ng-container>
      </div>
      <p-paginator
        *ngIf="showPagination()"
        [rows]="48"
        [first]="firstPage"
        [totalRecords]="pageResponse?.totalElements || 0"
        (onPageChange)="onPageChange($event)"
      ></p-paginator>

      <app-subcategory-description
        [subCategory]="subCategorySelected"
      ></app-subcategory-description>
    </div>
  </div>
</div>
